import { computed, inject, Service } from '@angular/core';
import type { OnyxPreferencesService } from '@onyx/angular';
import { AuthStore } from '../../auth/common/stores/auth.store';
import { OrderRateType } from '../../dashboard/orders/common/enums/order-rate-type';
import { Country } from '../enums/country';
import { FuelType } from '../enums/fuel-type';
import { VatRate } from '../enums/vat-rate';

@Service()
export class PreferencesService implements OnyxPreferencesService {
  private readonly authStore = inject(AuthStore);

  public defaultAreaCode = computed(() => '+48');
  public defaultCurrency = computed(
    () => this.authStore.business()?.defaultCurrency ?? 'eur',
  );
  public defaultCountry = computed(
    () =>
      (this.authStore.business()?.mainAddress?.countryCode ??
        Country.PL) as Country,
  );
  public defaultFuelType = computed(() => FuelType.DIESEL);
  public defaultRateType = computed(() => OrderRateType.FREIGHT);
  public defaultVatRate = computed(() => VatRate.RATE_23);
}
